module.exports = __webpack_public_path__ + "../static/img/logo-light.4532aed2.png";